import services from './../../../services/service'; // Service Class
import validation from './../../../services/validation'; // Validation
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer
import ProductForm from '../../../components/product/ProductForm.vue'
import NewPost from '../../../components/posts/newpost.vue'
import NewGallery from '../../../components/posts/newgallery.vue'
import NewProductGallery from '../../../components/posts/newproductgallery.vue'
import MenuModal from '../../../components/menumodal.vue'
import MenuLeftBar from '../../../components/menuleftbar.vue'

import vueSlider from 'vue-slider-component'
let service = new services();
let validator = new validation();
export default {
    name: 'Sellpoint',
    data () {
        return {
            child_route_view:false,
            loading:false,
            loggedIn:false,
            user: {},
            sellpoint: {},
            categories:{},
            main_category:{},
            sub_categories:[],
            filters:{},
            selected_filters:[],
            orders:{},
            notifications:{},
            messages:{},
            details:{},
            cities:{},
            states:{},
            contact_form: {},
            category:{},
            service:{},
            delivery_option:{},
            discount_coupon:{},
            products_unfiltered:{},
            products: {},
            product:{},
            product_item: {},
            market:{},
            subscriptions:{},
            services:{},
            posts:{},
            galleria:{},
            can_edit: false,
            edit_mode:false,
            disable_btn: false,
            setPanel: false,
            listView:true,
            marketView:false,
            addPanel:false,
            addProductPanel:false,
            addPostPanel:false,
            addGalleryPanel:false,
            addProductGalleryPanel:false,
            spProductsPanel:false,
            spMarketPanel:false,
            spProfilePanel:false,
            spContactPanel:false,
            spDeliveryPanel:false,
            spMessagesPanel:false,
            spOrdersPanel:false,
            spServicesPanel:false,
            spBlogPanel:false,
            spGalleryPanel:false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            spSettingsPanel:false,
            spSubscriptionPanel:false,
            setDiscount:false,
            viewDiscounts:true,
            createSellpointPanel: false,
            viewAllProductsBanner:false,
            showSidebarMobile:false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            visitor_url: service.request_url,
            visitor_app: service.request_from,
            bg_main:'',
            other_delivery_option:false,
            edit_other_delivery_option:false,
            set_bank_details: false,
            edit_city:false,
            ipaddress: "",
            notifications_unread: 0,
            siteUrl:"",
            default_banner_image:"https://res.cloudinary.com/diprbfy7s/image/upload/v1550754799/businesses_files/sp-default-banner.jpg",
            copied:false,
            // slider_type:[ 0,200 ],
            slider_type:[],
            slider_options:{
                min: 0,
                max: 0,
                width: "80%",
                processStyle: {
                    // "backgroundImage": "-webkit-linear-gradient(left, #f05b72, #3498db)"
                    "backgroundImage": "-webkit-linear-gradient(left, #333333, #3498db)"
                  }
            },
            price_filter_is_set:false,
            color_filter_is_set:false,
            size_filter_is_set:false,
            brand_filter_is_set:false,
            product_search_messsage:"",
            filter_array:[],
            sorting_by: 'best-match',
            sellpoint_product_item_groups:{},
            sellpoint_product_sizes:{},
            sellpoint_product_services:{},
            search_data: "",
            //bottombar mobile attr
            bottombar_search:false,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'product-form': ProductForm,
        'new-post-form': NewPost,
        'new-gallery-form': NewGallery,
        'new-product-gallery-form': NewProductGallery,
        'menu-modal': MenuModal,
        'menu-left-bar': MenuLeftBar,
        'vue-slider': vueSlider
     },
    methods: {
        closeMobileBottomBar(){
            document.getElementById("mobileBottomBar").style.display = "none";
        },
        mobileBottomBarActions(attr1,attr2){
            document.getElementById("mobileBottomBar").style.display = "block";

            if(attr1 == 'display-search-bar'){
                this.bottombar_search = true;
            }

        },
        mobileSideNavToggle(action){
            if(action == "open"){
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if(action == "close"){
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        mouseover(){
            var x = document.getElementById("product-action-display-menu");
            x.style.display = "block";
            // if (x.style.display === "none") {
            //     x.style.display = "block";
            // } else {
            //     x.style.display = "none";
            // }
        },
        mouseleave(){
            //document.getElementById("product-action-display-menu").display = "none";
            var x = document.getElementById("product-action-display-menu");
          //  x.style.display = "block";
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        showSectionById(section){
            var x = document.getElementById(section);
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        copyLink() {
            if(this.copied){
                this.copied = false;
            }else{
                this.$clipboard(this.siteUrl)
                this.copied = true;
            }
           
        },

        checkIfVideo(url){
            // return filename.split('.').pop();
            let ext = url.split('.').pop();
            if(service.video_exts.includes(ext)){
                return true;
            }else{
                return false;
            }
        },

        setComponent(attr1,attr2){
            this.setPanel = true;
            //close pop-up menu if open
            $('#menuModal').modal('hide');

            //route-viewing-off
            this.child_route_view = false;
            //route-viewing-off
            //
            //window.location.hash = '#spMain';//jump to div

            //BETTER - srolls to the very top
            // var top = document.getElementById("spMain").offsetTop; //Getting Y of target element
            // window.scrollTo(0, top); 

            //close sidenav mobile menu when option clicked, if open
            document.getElementById("mobileSideNav").style.width = "0";
            
            if(attr1 == 'create-sellpoint'){
                this.createSellpointPanel= true;
                this.addProductPanel= false;
            }
            if(attr1 == 'sellpoint-panel'){
                this.addPanel = false;
                this.addProductPanel= false;
                this.addPostPanel= false;
                this.addGalleryPanel= false;
            }
            if(attr1 == 'spProductsPanel'){
                if(attr2 == 'show-products'){
                    this.products = this.products_unfiltered; //unfiltered in case main products was altered
                }
                this.spMarketPanel = false;
                this.spProductsPanel= true;
                this.spProfilePanel=false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                //check for market
                if(attr2 == 'market'){
                    this.spMarketPanel = true;
                }
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if(attr1 == 'spProfilePanel'){
                this.spProductsPanel= false;
                this.spProfilePanel= true;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if(attr1 == 'spContactPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= true;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if(attr1 == 'spDeliveryPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spDeliveryPanel = true;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if(attr1 == 'spMessagesPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spDeliveryPanel = false;
                this.spOrdersPanel = false;
                this.spMessagesPanel = true;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if(attr1 == 'spOrdersPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = true;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
            }
            if(attr1 == 'spSettingsPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = true;
                this.spSubscriptionPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
                
            }
            if(attr1 == 'spSubscriptionPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = true;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = false;
                
            }
            if(attr1 == 'spServicesPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = false;
                this.spServicesPanel = true;
                
            }
            if(attr1 == 'spBlogPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spServicesPanel = false;
                this.spGalleryPanel = false;
                this.spBlogPanel = true;
                
            }
            if(attr1 == 'spGalleryPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
                this.spSubscriptionPanel = false;
                this.spServicesPanel = false;
                this.spBlogPanel = false;
                this.spGalleryPanel = true;
                
            }
            if(attr1 == 'add-product'){
                this.addPanel = true;
                this.addProductPanel= true;
                this.addPostPanel= false;
                this.addGalleryPanel= false;
                this.addProductGalleryPanel= false;
                this.createSellpointPanel= false;
            }
            if(attr1 == 'add-post'){
                this.addPanel = true;
                this.addPostPanel= true;
                this.addProductPanel= false;
                this.addGalleryPanel= false;
                this.addProductGalleryPanel= false;
                this.createSellpointPanel= false;
            }
            if(attr1 == 'add-gallery'){
                this.addPanel = true;
                this.addGalleryPanel= true;
                this.addProductGalleryPanel= false;
                this.addProductPanel= false;
                this.addPostPanel= false;
                this.createSellpointPanel= false;
            }
            if(attr1 == 'add-product-gallery'){
                this.addPanel = true;
                this.addProductGalleryPanel= true;
                this.addGalleryPanel= false;
                this.addProductPanel= false;
                this.addPostPanel= false;
                this.createSellpointPanel= false;
            }
            if(attr1 == 'edit-category'){
                this.category.edit = false;
                this.category = attr2;
                this.category.edit = true;
            }
            if(attr1 == 'reset-edit-category'){
                this.category.edit = false;
                this.category = {}
            }
            
            if(attr1 == 'view-all-products'){
                this.viewAllProductsBanner = false;
                this.products = this.products_unfiltered;
                //this.getSellpointProducts();
            }
            if(attr1 == 'list-view'){
                this.marketView = false;
                this.listView = true;
            }
            if(attr1 == 'market-view'){
                this.marketView = true;
                this.listView = false;
            }
            if(attr1 == 'add-delivery-information'){
                this.addDeliveryInformation = true;
            }
            if(attr1 == 'set-discount'){
                this.setDiscount = true;
                this.viewDiscounts = false;
                this.discount_coupon.edit = false;
            }
            if(attr1 == 'view-discounts'){
                this.discount_coupon.edit = false;
                this.setDiscount = false;
                this.viewDiscounts = true;
            }
        },

        setComponentActions(attr1,attr2){
            if(attr1 == 'edit-service'){
                this.service.edit_set = false;
                this.service = attr2;
                this.service.edit_set = true;
            }
            if(attr1 == 'edit-delivery-option'){
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
                //prepare city data
                this.getCities(this.delivery_option.business_delivery_state,'edit'); //option edit
            }
            if(attr1 == 'edit-tagline'){
                this.details = {};
                this.details.tagline_edit = true;
            }
            if(attr1 == 'edit-profile'){
                this.details = {};
                this.details.profile_edit = true;
            }
            if(attr1 == 'edit-contact-info'){
                this.details = {};
                this.details.contact_info_edit = true;
            }
            if(attr1 == 'edit-delivery-information'){
                this.details = {};
                this.details.delivery_edit = true;
            }
            if(attr1 == 'edit-bank-details'){
                this.details = {};
                this.details.bank_details_edit = true;
                this.set_bank_details = true;
            }
            if(attr1 == 'reset-delivery-information'){
                this.addDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = false;
            }
            if(attr1 == 'edit-discount-coupon'){
                this.viewDiscounts = false;
                this.discount_coupon.edit = false;
                this.setDiscount = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }
            if(attr1 == 'reset-discount-coupon'){
                this.viewDiscounts = true;
                this.discount_coupon.edit = false;
                this.discount_coupon = {};
                this.setDiscount = false;
            }
            if(attr1 == 'reset-edit'){
                this.details = {};
            }
        },
        
        prep: function() {
            var reg = new RegExp("www|sitename|test|localhost:2082");
            var parts = window.location.host.split(".");
            //return Home;
            return parts[0];
        },

        syncset(){
            //get auth key
            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.site_url,
                request_from: service.site_name,
                request_status: "SENDING...",
                request: service.request_url_page, //still same origin request
            } 
            if(credentials.session_key != null) {
                //save session and request on server
                service.sessionSync(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        //redirect to sp with session ref
                        let ref = response.body.data;
                        window.location.href = service.request_url+'/manage/'+ref;
                    }
                }).catch((err) => {
                    if(err) {
                        console.log(err)
                       // this.$router.push('login');
                    }
                })
            }
        },

        toggleSidebar(){
            if(this.showSidebarMobile == true){
                this.showSidebarMobile = false;
            }else{
                this.showSidebarMobile = true;
            }
        },
        toggleFilterSortBoard(){
            var x = document.getElementById("filterSortBoard");
            if (x.style.display === "none") {
                x.style.display = "block";
                ///...commented for now......document.getElementById("showFilters").style.display = "none"; //hide show btn
            } else {
                x.style.display = "none";
                ///...commented for now......document.getElementById("showFilters").style.display = "block"; //show show btn
            }
        },

        resetFilterSortOptions(){
            this.products = this.products_unfiltered;
            this.setComponent("spProductsPanel","")
        },

        filterByPrice(){
            this.products = this.products_unfiltered;
            let self = this;
            this.products =  this.products.filter(function(product){ return product.product_price_range >= self.slider_type[0] && product.product_price_range <= self.slider_type[1]});
            this.setComponent("spProductsPanel","")
        },
        sortBy(sort_by){
            this.sorting_by = sort_by;

            //check if products are filtered
            if(this.filter_array.length == 0){ //filtering did not happen
                //use unfiltered products
                this.products = this.products_unfiltered;
            } //else use the already filtered products
            
            let self = this;
            let sorted_array = [];

            //featured
            if(sort_by == 'featured'){
                sorted_array = this.products.filter(function(product){ return product.product_is_featured == true;});
                if(sorted_array.length != 0){
                   //order the sorted array
                    let orderd_sorted_array = this.local_sort_by_key(sorted_array,"product_featured_reg_date_f")
                    this.products = orderd_sorted_array.reverse(); //show in desc
                    this.product_search_messsage = "Showing Featured Products from list";
                }
            }

            //orders-made
            if(sort_by == 'orders-made'){
                sorted_array = this.local_sort_by_key(this.products,"product_total_items_orders");
                this.products = sorted_array.reverse();
                this.product_search_messsage = "Showing Products from Highest to lowest Orders";
            }

            //discounted
            if(sort_by == 'discounted'){
                sorted_array = this.products.filter(function(product){ return product.product_is_discounted != 0;});
                if(sorted_array.length != 0){
                   //order the sorted array by date
                    this.products = this.local_sort_by_key(sorted_array,"product_reg_date_f");
                    this.product_search_messsage = "Showing Discounted Products from the list";
                }
            }

            //pre-orders
            if(sort_by == 'pre-orders'){
                sorted_array = this.products.filter(function(product){ return product.product_is_featured == true;});
                if(sorted_array.length != 0){
                   //order the sorted array
                    this.products = this.local_sort_by_key(sorted_array,"product_featured_reg_date_f");
                    this.product_search_messsage = "Showing Products that you can Pre Order";
                }
            }

            //price-low-high
            if(sort_by == 'price-low-high'){
                sorted_array = this.local_sort_by_key(this.products,"product_price_range");
                this.products = sorted_array;
                this.product_search_messsage = "Showing Products from Lowest to Highest prices";
            }

            //price-high-low
            if(sort_by == 'price-high-low'){
                sorted_array = this.local_sort_by_key(this.products,"product_price_range");
                //order the sorted array in desc
                this.products = sorted_array.reverse();
                this.product_search_messsage = "Showing Products from Highest to Lowest prices";

            }

            //show no result message
            if(sorted_array.length == 0){
                this.product_search_messsage = "No Products found...showing related matches";
            }
            //to aid filtering
            if(this.filter_array.length != 0){
                this.product_search_messsage = "";
            }
            
            this.setComponent("spProductsPanel","")
        },
        local_sort_by_key(array, key)
        {
            return array.sort(function(a, b)
            {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
        },

        filterBy(filter_key,filter_key_value_id,filter_key_value){
            //set new array_row
            //first check if in array
            let array_row = [filter_key,filter_key_value_id,filter_key_value];
            
            if(this.filter_array.length != 0){
                const index = this.filter_array.findIndex(c => c[1] === filter_key_value_id);
                if(index < 0){
                    this.filter_array.push(array_row);
                }
            }else{
                this.filter_array.push(array_row);
            }
            //filter current sorted data with filter array options
            let filtered_array = [];
            let data = this.filter_array;
            //loop through array
            data.forEach(function(row) {
                //filter_key == category
                if(row[0] == 1){
                    let products_to_filter = this.products_unfiltered;
                    products_to_filter.forEach(function(product) {
                        if(product.product_category_id == row[1]){
                            //push into filtered_array but check first to know if its there
                            if(filtered_array.length != 0){
                                const index = filtered_array.findIndex(p => p.product_id === product.product_id );
                                if(index < 0){
                                    filtered_array.push(product);
                                }
                            }else{
                                filtered_array.push(product);
                            }
                        }
                    }, this);
                }

                //filter_key == color..subscriptions..ie product item groups
                if(row[0] == 2){
                    let products_to_filter = this.products_unfiltered;
                    products_to_filter.forEach(function(product) {
                        //loop through product groups
                        product.product_item_groups.forEach(function(group) {
                            if(group.product_item_group_name == row[2]){
                                //push into filtered_array but check first to know if its there
                                if(filtered_array.length != 0){
                                    const index = filtered_array.findIndex(p => p.product_id === product.product_id );
                                    if(index < 0){
                                        filtered_array.push(product);
                                    }
                                }else{
                                    filtered_array.push(product);
                                }
                            }
                        }, this);
                    }, this);

                }

                //filter_key == product_size
                if(row[0] == 3){
                    let products_to_filter = this.products_unfiltered;
                    products_to_filter.forEach(function(product) {
                        //loop through productitems
                        product.product_items.forEach(function(item) {
                            if(item.product_item_size == row[2]){
                                //push into filtered_array but check first to know if its there
                                if(filtered_array.length != 0){
                                    const index = filtered_array.findIndex(p => p.product_id === product.product_id );
                                    if(index < 0){
                                        filtered_array.push(product);
                                    }
                                }else{
                                    filtered_array.push(product);
                                }
                            }
                        }, this);
                    }, this);

                }

                //filter_key == product_services
                if(row[0] == 4){
                    let products_to_filter = this.products_unfiltered;
                    products_to_filter.forEach(function(product) {
                        //loop through product items
                        product.product_items.forEach(function(item) {
                            if(item.product_item_service_tag == row[2]){
                                //push into filtered_array but check first to know if its there
                                if(filtered_array.length != 0){
                                    const index = filtered_array.findIndex(p => p.product_id === product.product_id );
                                    if(index < 0){
                                        filtered_array.push(product);
                                    }
                                }else{
                                    filtered_array.push(product);
                                }
                            }
                        }, this);
                    }, this);

                }


                //..
            }, this);

            if(filtered_array.length != 0)
                this.products = filtered_array;
             else{
                 this.products = this.products_unfiltered;
             }
            //sort the products based on the current set sort parameter
            this.sortBy(this.sorting_by);
           
            
            //if result is empty ..//filter unfiltered data
            this.setComponent("spProductsPanel","")
        },

        //search business
        searchProductsByBusiness(){
            service.searchProductsByBusiness(this,this.search_data,this.sellpoint.business_username).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    this.product.product_search_messsage = "Showing search result for "+ this.search_data;
                    if(this.products.length == 0){
                        this.product.product_search_messsage = "No products found";
                    }
                    this.setComponent("spProductsPanel","");
                }
            }).catch((err) => {})
        },

        preset() {
            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;//loggedIn options
                            //set sellpoint and seller options
                           this.setSellpoint();
                        }, this);
                    }else {
                      //  console.log(response)
                      this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        console.log(err)
                        //this.$router.push('login');
                    }
                })
            }else {
               //console.log("error 2")
               this.$router.push('login');
            }
        },

        is_editing(){ //preseting if seller
            if(this.user.user_id != ""){
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                }
                service.can_edit(this, payload).then(response => {
                    if(response.body.status == 200) {
                        this.edit_mode =  true;
                        this.can_edit = true;
                    }else {
                        this.edit_mode =  false;
                    }
                }).catch((err) => {
                    if(err) {
                        //log error
                    }
                })
            }
        },

        switchMode(){
            if(this.edit_mode == false){
                this.is_editing(); //revalidate seller
            }else{
                this.edit_mode = false;
                this.can_edit = true;
            }
        },

        //getIPAddress
        getIPAddress(){
            service.getIPAddress(this).then(response => {
                this.ipaddress = response.data
            }).catch((err) => {})
        },
        
        getStates(){
            service.getStates(this).then(response => {
                if(response.body.status == 200) {
                    this.states = response.body.data;
                }
            }).catch((err) => {})
        },

        getCities(state,option){
            if(option == "edit"){this.edit_city = true;}
            else{this.edit_city = false}
            service.getCities(this,state).then(response => {
                if(response.body.status == 200) {
                    this.cities = response.body.data;
                }
            }).catch((err) => {})
        },

        setOtherOptions(v,o){
            if(v != undefined){
                if(v == "other"){
                    this.other_delivery_option = true;
                    if(o == "edit"){this.edit_other_delivery_option = true;}//for edit
                }
                if(v == "all"){
                    this.delivery_option.business_delivery_other_option = "nill";
                    if(o == "edit"){this.edit_other_delivery_option = false;}//for edit
                    this.other_delivery_option = false;
                }
            }
            
        },

        setSellpoint(){
            this.loading = true;
            let sp = "";
            if(this.$route.params.id != undefined){
                sp = this.$route.params.id;
             }
            else{
                sp = this.prep();
            }
            service.getBusinessByUserName(this, sp).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data;
                    localStorage.setItem("sp#cp",this.sellpoint.business_username); //current viewing page
                    document.title = this.sellpoint.business_name + " | SP";
                    localStorage.setItem("sp_#_sellpoint",this.sellpoint.business_username); //use storage for now if buggy set in as url get param
                    
                    this.siteUrl = service.siteUrl+"?s="+this.sellpoint.business_username
                    +"&s1="+encodeURI(this.sellpoint.business_name)
                    +"&s2="+encodeURI(this.sellpoint.business_name)
                    +"&s3="+encodeURI(this.sellpoint.business_tagline)
                    +"&s4="+this.sellpoint.business_banner_image
                    +" ";

                    this.is_editing();
                    // this.getCategories(this.sellpoint.business_category_id);
                    // this.getSellpointProducts(); // if basic sellpoint
                    if(this.sellpoint.business_market_category_id != 1){ //put in promise hub if slow
                        this.getSellpointMarket();
                        // this.getSellpointMarketProducts();
                       // localStorage.setItem("sp_#_sellpoint",this.sellpoint.business_username);
                    }
                    this.prepareFilters();

                    //-nowdefault this.spProductsPanel = true; //use loaders subsequently to make sure other above is loaded
                    if(this.sellpoint.business_layout == 1){ //shop
                        this.spProductsPanel=true;
                    }else if(this.sellpoint.business_layout == 2){ //services
                        this.spServicesPanel=true;
                    }else if(this.sellpoint.business_layout == 3){ //gallery
                        this.spGalleryPanel=true;
                    }else if(this.sellpoint.business_layout == 4){ //blog
                        this.spBlogPanel=true;
                    }else {
                        this.spProductsPanel=true; //default
                    }

                    this.loading = false;

                    //get other info
                    // this.getSellpointNotifications();
                    // this.getSellpointMessages();
                    // this.getSellpointOrders();
                    //promises hub
                    let promises = [];
                    for (let i = 0; i < 9; ++i) {
                        if(i == 1){
                            promises.push(
                                this.getCategories(this.sellpoint.business_category_id)
                            )
                        }
                        if(i == 2){
                            promises.push(
                                this.getSellpointProducts() // if basic sellpoint
                            )
                        }
                        if(i == 3){
                           promises.push(
                                this.getSellpointNotifications()
                            )
                        }
                        
                        if(i == 4){
                            promises.push(
                                this.getSellpointMessages()
                            )
                        }

                        if(i == 5){
                            promises.push(
                                this.getSellpointOrders()
                            )
                        }

                        if(i == 6){
                            promises.push(
                                this.getFilters()
                            )
                        }
                        if(i == 7){
                            promises.push(
                                this.getPosts()
                            )
                        }
                        if(i == 8){
                            promises.push(
                                this.getGalleryPosts()
                            )
                        }
                    }
                
                    //process all promises
                    Promise.all(promises)
                    .then(() => {
                        //process one by one to implement wait time
                        var result = Promise.resolve();
                        promises.forEach(promise => { //loop through each promise and resolve one after the other
                            result.then(() => {});
                        });
                    })
                    .catch((e) => {});
                //..promises hub
                    
                }else{
                   // location.reload(true); //manage with this for now
                  //  console.log(response)
                   //this.$router.push('login');
                   
                }
            }).catch((err) => {
                //log it
                //location.replace("/");
              console.log(err);
              this.loading = true;
            })
        },

        prepareFilters(){
            //loop through business filters
            this.sellpoint.business_filters.forEach(function(filter) {
                if(filter.business_filter_id == 2){this.price_filter_is_set = true}
                if(filter.business_filter_id == 3){this.color_filter_is_set = true}
                if(filter.business_filter_id == 4){this.size_filter_is_set = true}
            }, this);
        },

        getSellpointNotifications(){
            service.getBusinessNotifications(this, this.sellpoint.business_username).then(response => {
                if(response.body.status == 200) {
                    this.notifications = response.body.data;
                    this.notifications_unread = response.body.data_1;
                }
            }).catch((err) => {})
        },

        getSellpointMessages(){
            service.getBusinessMessages(this, this.sellpoint.business_username).then(response => {
                if(response.body.status == 200) {
                    this.messages = response.body.data;
                }
            }).catch((err) => {})
        },

        getSellpointOrders(){
            service.getBusinessOrders(this, this.sellpoint.business_username).then(response => {
                if(response.body.status == 200) {
                    this.orders = response.body.data;
                }
            }).catch((err) => {})
        },

        getSellpointProducts(){
            service.getBusinessProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    this.products_unfiltered = response.body.data;
                    //set price filter range
                    this.slider_type = [response.body.min_price_range,response.body.max_price_range]
                    this.slider_options.min = response.body.min_price_range;
                    this.slider_options.max = response.body.max_price_range;
                    //set other filters
                    this.sellpoint_product_item_groups = response.body.data_product_items_groups_filtered;
                    this.sellpoint_product_sizes = response.body.data_product_sizes_filtered;
                    this.sellpoint_product_services = response.body.data_product_services_filtered;
                }
            }).catch((err) => {})
                
        },

        getSellpointMarketProducts(){
            service.getMarketProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                }
            }).catch((err) => {})
                
        },
        getMarketMainProductsAsSubscriptions(){
            service.getBusinessProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.subscriptions = response.body.data;
                }
            }).catch((err) => {})
                
        },

        getSellpointMarket(){
            service.getBusinessMarket(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.market = response.body.data;
                    this.getMarketMainProductsAsSubscriptions();
                    this.getSellpointMarketProducts();
                }
            }).catch((err) => {
                this.getIPAddress();
                this.market = {};
               // set error payload
               let err_payload = {
                    err_int_id: this.user.user_id || 0,
                    err_mod_id: 5, //sellpoint page
                    err_route: this.$route.path,
                    err_func: "getSellpointMarket",
                    err_api_cl: "GET::"+err.url,
                    err_message: err.bodyText,
                    err_ln_rang: '363-377',
                    err_poss_cos: "returned could be 404 || 400",
                    err_ip_address: this.ipaddress
                }
                //service.sendErrorLog(this, err_payload).then().catch(() => {})
                //send error to log
            })
                
        },
        getPosts(){
            service.getPointPosts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.posts = response.body.data;
                }
            }).catch((err) => {})
                
        },
        getGalleryPosts(){
            service.getPointGalleryPosts(this, this.sellpoint.business_id,0,50,0,50).then(response => {
                if(response.body.status == 200) {
                    this.galleria = response.body.data;
                }
            }).catch((err) => {})
        },

        getFilters(){
            service.getFilters(this).then(response => {
                if(response.body.status == 200) {
                    this.filters = response.body.data;
                }
            }).catch((err) => {})
                
        },

        //DEPRAC
        // getCategories(category){
        //     service.getBusinessSubCategories(this, category).then(response => {
        //        if(response.body.status == 200) {
        //             this.categories = response.body.data;
        //         }
        //     }).catch((err) => {})
                
        // },

        getCategories(category){
            service.getMainCategories(this, category).then(response => {
               if(response.body.status == 200) {
                    this.categories = response.body.data;
                }
            }).catch((err) => {})
                
        },

        getSubCategories(category){
            if(category != undefined){
                this.sub_categories = category.sub_categories;
            }else{
                this.sub_categories = [];
            }
            
        },

        addCategory(){
            var payload = {
                category_new: this.category.new_category || 0,
                category_new_listed: this.category.new_listed_category || "nill",
                business_id: this.sellpoint.business_id
            }
            service.addCategory(this, payload).then(function(data) {
                if(data.body.status == 201) {
                    toastr.success("Sellpoint Category Added Successfull", 'Success!');
                    this.sellpoint.business_categories = data.body.data;
                    this.category = {};
                }
            }).catch((err) => {
                //log it
            })
        },

        editCategory(){
            this.category.business_id = this.sellpoint.business_id;
            service.editCategory(this, this.category).then(function(data) {
                if(data.body.status == 200) {
                    toastr.success("Sellpoint Category edited", 'Success!');
                    this.sellpoint.business_categories = data.body.data;
                    this.category = {};
                }
            }).catch((err) => {
                //log it
                this.category = {};
            })
        },

        getCategoryProducts(category){
            let products_to_filter = this.products_unfiltered;
            let fetch_array = []; //empty
            products_to_filter.forEach(function(product) {
                if(product.product_category_id == category.business_category_id){
                    //push into filtered_array but check first to know if its there
                    fetch_array.push(product);
                        
                }
            }, this);
            this.products = fetch_array;
            this.setComponent("spProductsPanel","");
            this.viewAllProductsBanner = true;
            ///...stopped calling from server
            // service.getCategoryProducts(this, category.business_category_id).then(response => {
            //     if(response.body.status == 200) {
            //         this.products = response.body.data;
            //         this.viewAllProductsBanner = true;
            //         this.showSidebarMobile = false;
            //     }
            // }).catch((err) => {})
        },

    //     createSellpoint(){
    //         this.disable_btn = true;
    //         this.business.agree = true;
    //         var credentials = {
    //             business_name: this.business.business_name,
    //             business_category: this.business.business_category || 1,
    //             business_owner: this.user.user_id,
    //         }
    //         let navi = this.$router;
    //        if(credentials.business_name != undefined && credentials.business_category != undefined) {
    //             if(this.business.agree) {
    //                 service.addBusiness(this, credentials).then(function(data) {
    //                     if(data.body.status == 201) {
    //                         toastr.success("Sellpoint Creation Successfull", 'Success!');
    //                         //log user in
    //                         this.business = data.body.data;
    //                         this.setComponent('add-product','');
    //                     }
    //                 }).catch((err) => {
    //                     if(err) {
    //                         toastr.warning("Something went wrong", 'Warning!'); 
    //                         this.disable_btn = false;
    //                         console.log(err)
    //                     }
    //                 })
    //             }else {
    //                 toastr.error('Please agree to Terms', 'Warning!');
    //                 this.disable_btn = false;
    //             }
    //         }else {
    //             toastr.error('Kindly fill all fields', 'Warning!');
    //             this.disable_btn = false;
    //         }
    // },

         //uploads
    onFileChange(e,type) {
        let files = e.target.files || e.dataTransfer.files;
        if (files.length)
        {
            let formData = new FormData();
            formData.append('photo', files[0]);
            formData.append('data_id', this.sellpoint.business_id); 
            formData.append('data_type', type); 
            service.uploadBusinessDataPhoto(this, formData).then(data => {
                if(data.body.status == 200){
                    if(type == "business_banner_image"){
                        this.sellpoint.business_banner_image = data.body.data;
                    }
                    if(type == "business_brand_image"){
                        this.sellpoint.business_brand_image = data.body.data;
                    }
                }
                }).catch((err) => {
                    if(err) {
                       // log it
                    }
            })
        }   
            
    },

    addService(){
        var payload = {
            business_service: this.service.service_name || "Service Details",
            business_id: this.sellpoint.business_id
        }
        service.addService(this, payload).then(function(data) {
            if(data.body.status == 201) {
                toastr.success("Sellpoint Service Added Successfully", 'Success!');
                this.sellpoint.business_services = data.body.data;
                this.service = {};
            }
        }).catch((err) => {
            //log it
            this.service = {};
        })
    },

    editService(){
        this.service.business_id = this.sellpoint.business_id;
        service.editService(this, this.service).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Sellpoint Service edited",'Success!');
                this.sellpoint.business_services = data.body.data;
                this.service.edit_set = false;
                this.service = {};
            }
        }).catch((err) => {
            //log it
            this.service = {};
        })
    },

    

    addDeliveryOption(){
        var payload = {
            business_delivery_state: this.delivery_option.state,
            business_delivery_city: this.delivery_option.city || 0,
            business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
            business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
            business_id: this.sellpoint.business_id
        }
        if(payload.business_delivery_option_price == 0){
            toastr.warning("Delivery Charge not Added", 'Warning!');
        }else{
            if((payload.business_delivery_option != 0) || (payload.business_delivery_other_option != "nill")){
                service.addDeliveryOption(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        toastr.success("Sellpoint Delivery Details Added Successfully", 'Success!');
                        this.sellpoint.business_delivery_options = data.body.data;
                        this.delivery_option = {};
                        this.addDeliveryInformation = false;
                    }
                }).catch((err) => {
                    //log it
                    this.delivery_option = {};
                })
            }else{
                toastr.warning("Select a delivery option", 'Warning!');
            }
        }
        
    },

    editDeliveryOption(){
        var payload = {
            business_id: this.sellpoint.business_id,
            business_delivery_state: this.delivery_option.business_delivery_state,
            business_delivery_city: this.delivery_option.city || 0,
            business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
            business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
            business_delivery_option_id: this.delivery_option.business_delivery_option_id
        }
        //this.delivery_option.business_id = this.sellpoint.business_id;
        if(payload.business_delivery_option_price == 0){
            toastr.warning("Delivery Charge not Added", 'Warning!');
        }else{
            if((payload.business_delivery_option != 0) || (payload.business_delivery_other_option != "nill")){
                service.editDeliveryOption(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    toastr.success("Sellpoint Delivery Details edited",'Success!');
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.editDeliveryInformation = false;
                    //this.delivery_option = {};
                }
                }).catch((err) => {
                    //log it
                    //this.delivery_option = {};
                    this.delivery_option.edit_set = false;
                        this.editDeliveryInformation = false;
                })
            }else{
                toastr.warning("Select a delivery option", 'Warning!');
            }
        }
    },

    deleteDeliveryOption(id){
        var payload = {
            business_id: this.sellpoint.business_id
        }
        service.deleteDeliveryOption(this, id, payload).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Sellpoint Delivery Details deleted",'Success!');
                this.sellpoint.business_delivery_options = data.body.data;
                this.delivery_option.edit_set = false;
                this.delivery_option = {};
            }
        }).catch((err) => {
            //log it
            this.delivery_option = {};
        })
    },

    //delivery option

    editBusinessDetails(attr){
        if(attr == "tagline"){
            var payload = {
                business_id: this.sellpoint.business_id,
                business_tagline: this.sellpoint.business_tagline
            }
        }
        if(attr == "profile"){
            var payload = {
                business_id: this.sellpoint.business_id,
                business_profile: this.sellpoint.business_profile
            }
        }
        if(attr == "contact_info"){
            var payload = {
                business_id: this.sellpoint.business_id,
                business_emails: this.sellpoint.business_emails,
                business_address: this.sellpoint.business_address,
                business_phones: this.sellpoint.business_phones
            }
        }
        if(attr == "delivery"){
            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_information: this.sellpoint.business_delivery_information
            }
        }
        service.editBusinessDetails(this, payload).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Sellpoint edited", 'Success!');
            }
             this.details = {};
        }).catch((err) => {
            //log it
            this.details = {};
        })
    },

    sendBusinessContactForm(){
        var payload = {
            business_id: this.sellpoint.business_id,
            contact_form_name: this.contact_form.name || "nill",
            contact_form_email: this.contact_form.email || "nill",
            contact_form_message: this.contact_form.message || "nill"
        }
        service.sendBusinessContactForm(this, payload).then(function(data) {
            if(data.body.status == 201) {
                toastr.success("Message Sent", 'Ok!');
            }
             this.contact_form = {};
        }).catch((err) => {
            //log it
            this.contact_form = {};
        })
    },

    //set coupons and discount
    setDiscountsAndCoupons(){
        //validate entry
        let entry_arr = [
            ["Discount or Coupon",this.discount_coupon.is_discount_coupon,"str"],
            ["Coupon Percentage",this.discount_coupon.discount_percentage,"num"],
            ["Discount Category",this.discount_coupon.discount_category,"num"],
            ["Start Date",this.discount_coupon.discount_start_date,"date"],
            ["End Date",this.discount_coupon.discount_end_date,"date"]
        ];
        let validated_arr = validator.validate_array(entry_arr,"Please fill in ");
        if(validated_arr.length == 0){
            var payload = {
                business_id: this.sellpoint.business_id,
                product_item_id: 0,
                is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C', //or coupon
                coupon_business_category:this.discount_coupon.discount_category,
                coupon_percentage: this.discount_coupon.discount_percentage,
                coupon_start_date: this.discount_coupon.discount_start_date,
                coupon_end_date: this.discount_coupon.discount_end_date,
            }
            service.setDiscountsAndCoupons(this, payload).then(function(data) {
                if(data.body.status == 201) {
                    toastr.success("New Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setComponentActions('reset-discount-coupon','');
                }
            }).catch((err) => {
                //log it
            })
        }else{
            validated_arr.forEach(function(error) {
                toastr.error(error); 
            }, this);
        }
        
    },

    // edit coupons and discount
    editDiscountsAndCoupons(){
        this.discount_coupon.business_id = this.sellpoint.business_id;
        service.editDiscountsAndCoupons(this, this.discount_coupon).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Discount Set", 'Update!');
                this.sellpoint.business_discounts_coupons = data.body.data;
                this.setComponentActions('reset-discount-coupon','');
            }
        }).catch((err) => {
            //log it
        })
    },

    
    // edit coupons and discount
    deactivateDiscountsAndCoupons(payload){
        payload.business_id = this.sellpoint.business_id;
        service.deactivateDiscountsAndCoupons(this, payload).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Discount Set", 'Update!');
                this.sellpoint.business_discounts_coupons = data.body.data;
                this.setComponentActions('reset-discount-coupon','');
            }
        }).catch((err) => {
            //log it
        })
    },

    //set bank details
    setBankDetails(){
        var payload ={
            business_bank_name: this.sellpoint.business_bank_details.bank_name,
            business_bank_account_name: this.sellpoint.business_bank_details.bank_account_name,
            business_bank_account_number: this.sellpoint.business_bank_details.bank_account_number,
            business_id:this.sellpoint.business_id
        }
       
        service.setBusinessBankDetails(this, payload).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Bank Details Set", 'Update!');
            }
            this.set_bank_details = false;
        }).catch((err) => {
            //log it
        })
    },

    //processing fee switch
    switchProcessingFee(to){
        var payload ={
            business_process_fee_pay: to,
            business_id:this.sellpoint.business_id
        }
       
        service.switchProcessingFeePay(this, payload).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Processing Fee Set", 'Reset!');
                this.sellpoint.business_processing_fee_pay_status = to;
            }
        }).catch((err) => {
            //log it
        })
    },

    //set filter options
    setFilterOptions(){
        var payload ={
            business_filters: this.selected_filters,
            business_id:this.sellpoint.business_id
        }
       
        service.setBusinessFilterOptions(this, payload).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Filter Options Set", 'Update!');
            }
            this.sellpoint.business_filters = data.body.data;
        }).catch((err) => {
            //log it
        })
    },

    //remove filter option
    removeFilterOption(option){
        var payload ={
            business_filter: option,
            business_id:this.sellpoint.business_id
        }
       
        service.removeBusinessFilterOption(this, payload).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Filter Option Removed", 'Update!');
            }
            this.sellpoint.business_filters = data.body.data;
        }).catch((err) => {
            //log it
        })
    },

    //read general notifications for all messages, orders and notifications
    readNotifications(){
        this.notifications_unread = 0; //read all
        var payload ={
            notification_type: "business",
            notification_module: "notifications",
            notification_business:this.sellpoint.business_username
        }
        service.readNotifications(this,payload).then(function(data) {}).catch((err) => {})
    },
   
},
mounted: function(){
    this.loading = true;
    if((localStorage.getItem("sp_token")) != undefined){
        this.preset();
    }else{
        this.setSellpoint()
    }
},
created: function(){
    this.loading = true;
    // if(this.$route.params.idp || this.$route.params.idg || this.$route.params.idpos){
    //     this.child_route_view = true;
    // }
    
    this.getStates();
    this.getIPAddress();
},
}


// WEBPACK FOOTER //
// ./src/pages/Buypoint/Buypoint/script.js